import React, { useContext, useState, useEffect } from "react";
import "../css/ModalConfigurarTurno.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTrash, faPen } from "@fortawesome/free-solid-svg-icons";
import ReactDOM from 'react-dom';
import Button from "./Button";
import { getPeriod, postPeriod, deletePeriod, putPeriod } from '../utils/peticionesApi';
import { NewContext } from "../utils/ContextProvider";

const ModalConfigurarTurno = ({ onClose }) => {
    const { getAlert } = useContext(NewContext);

    const [dataPeriodo, setDataPeriodo] = useState({
        name: '',
        start_time: '00:00',
        end_time: '00:00',
    });

    const [editandoId, setEditandoId] = useState(null);
    const [periodos, setPeriodos] = useState([]);
    const [pagina, setPagina] = useState(0);
    const porPagina = 4;

    const fetchPeriodos = async () => {
        try {
            const res = await getPeriod();
            if (res?.status === 200 && Array.isArray(res.data)) {
                setPeriodos(res.data);
            } else {
                setPeriodos([]);
            }
        } catch (error) {
            console.log("Error al obtener turnos:", error);
        }
    };

    useEffect(() => {
        fetchPeriodos();
    }, []);

    const handleChangePeriodo = (e) => {
        setDataPeriodo({ ...dataPeriodo, [e.target.name]: e.target.value });
    };

    const parseHora = (hora) => {
        if (!hora) return "00:00:00";

        if (typeof hora === "string") {
            // Si viene como "1,0", lo transformamos a "01:00:00"
            if (hora.includes(",")) {
                const [h, m] = hora.split(",").map((n) => parseInt(n));
                return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:00`;
            }

            // Si ya viene bien como "14:30", agregamos segundos
            if (hora.includes(":")) {
                const partes = hora.split(":");
                const h = partes[0].padStart(2, '0');
                const m = partes[1].padStart(2, '0');
                return `${h}:${m}:00`;
            }
        }

        return "00:00:00";
    };

    const guardarTurno = async () => {
        const { name, start_time, end_time } = dataPeriodo;

        if (!name.trim()) return getAlert({ msj: "Debe ingresar el nombre del turno.", tipe: "warning" });
        if (start_time === "00:00") return getAlert({ msj: "Debe seleccionar una hora de inicio.", tipe: "warning" });
        if (end_time === "00:00") return getAlert({ msj: "Debe seleccionar una hora de término.", tipe: "warning" });
        if (start_time >= end_time) return getAlert({ msj: "La hora de término debe ser mayor que la de inicio.", tipe: "warning" });

        try {
            const payload = {
                name,
                start_time: parseHora(start_time),
                end_time: parseHora(end_time)
            };

            const res = editandoId
                ? await putPeriod(editandoId, payload)
                : await postPeriod(payload);

            if (res?.status === 200 || res?.data?.code === 0) {
                getAlert({
                    msj: editandoId ? "Turno actualizado con éxito." : "Turno agregado con éxito.",
                    tipe: "succes"
                });
                setDataPeriodo({ name: '', start_time: '00:00', end_time: '00:00' });
                setEditandoId(null);
                await fetchPeriodos();
                onClose();
            }
        } catch (error) {
            console.log("Error al guardar turno:", error);
            getAlert({ msj: "Error al guardar turno.", tipe: "error" });
        }
    };

    const handleDelete = async (id) => {
        try {
            await deletePeriod(id);
            getAlert({ msj: "Turno eliminado con éxito.", tipe: "succes" });
            await fetchPeriodos();
        } catch (error) {
            console.log("Error al eliminar turno:", error);
            getAlert({ msj: "No se pudo eliminar el turno.", tipe: "error" });
        }
    };

    const paginados = periodos.slice(pagina * porPagina, (pagina + 1) * porPagina);

    const formatTime = (time) => {
        if (Array.isArray(time)) {
            const [h, m] = time;
            return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
        } else if (typeof time === 'string' && time.includes(':')) {
            return time.slice(0, 5); // de "14:30:00" → "14:30"
        }
        return "00:00";
    };

    return ReactDOM.createPortal(
        <div className="modal-config-turno">
            <div className="modal-overlay">
                <div className="modal-contenido">
                    <div className="modal-header">
                        <h3>{editandoId ? 'Editar Turno' : 'Agregar Turno'}</h3>
                        <button className="close-btn" onClick={onClose}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>

                    <div className="contenido-doble">
                        <div className="formulario-turno">
                            <div className="campo-turno">
                                <label>Nombre del Turno</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={dataPeriodo.name}
                                    onChange={handleChangePeriodo}
                                    placeholder="Ingrese el nombre"
                                    style={{ marginTop: "10px" }}
                                />
                            </div>

                            <div className="row-horarios">
                                <div className="campo-horario-inline">
                                    <label>Inicio</label>
                                    <input
                                        type="time"
                                        name="start_time"
                                        value={formatTime(dataPeriodo.start_time)}
                                        onChange={handleChangePeriodo}
                                    />
                                </div>
                                <div className="campo-horario-inline">
                                    <label>Término</label>
                                    <input
                                        type="time"
                                        name="end_time"
                                        value={formatTime(dataPeriodo.end_time)}
                                        onChange={handleChangePeriodo}
                                    />
                                </div>
                            </div>

                            <div className="footer">
                                <button onClick={onClose}>Cancelar</button>
                                {editandoId && (
                                    <button
                                        className="cancelar-edicion"
                                        onClick={() => {
                                            setEditandoId(null);
                                            setDataPeriodo({ name: '', start_time: '00:00', end_time: '00:00' });
                                        }}
                                    >
                                        Cancelar edición
                                    </button>
                                )}
                                <Button tipe="violeta" msj={editandoId ? "Actualizar Turno" : "Agregar Turno"} onClick={guardarTurno} />
                            </div>
                        </div>

                        <div className="tabla-turnos">
                            {periodos.length === 0 ? (
                                <p style={{ textAlign: 'center', color: '#777' }}>Sin turnos cargados</p>
                            ) : (
                                <>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Turno</th>
                                                <th>Inicio</th>
                                                <th>Fín</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginados.map((p, index) => (
                                                <tr key={index}>
                                                    <td>{p.name}</td>
                                                    <td>{formatTime(p.start_time)}</td>
                                                    <td>{formatTime(p.end_time)}</td>
                                                    <td>
                                                        <button className="icon-btn" onClick={() => handleDelete(p.id)}>
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                        <button className="icon-btn" onClick={() => {
                                                            setDataPeriodo({
                                                                name: p.name,
                                                                start_time: p.start_time?.slice(0, 5),
                                                                end_time: p.end_time?.slice(0, 5),
                                                            });
                                                            setEditandoId(p.id);
                                                        }}>
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <div className="paginacion-turnos">
                                        <button disabled={pagina === 0} onClick={() => setPagina(pagina - 1)}>Anterior</button>
                                        <button disabled={(pagina + 1) * porPagina >= periodos.length} onClick={() => setPagina(pagina + 1)}>Siguiente</button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ModalConfigurarTurno;
